export const API_URL = process.env.REACT_APP_API_URL as string;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY as string;
export const OLD_PORTALS_URL = process.env.REACT_APP_OLD_PORTALS_URL as string;
export const REPORTS_URL = process.env.REACT_APP_REPORTS_URL as string;
export const GIMBIL_URL = process.env.REACT_APP_GIMBIL_URL as string;
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const HOTJAR_ID = 3730120;
export const HOTJAR_VERSION = 6;
export const DYNATRACE_BASE_URL = 'https://znr05085.live.dynatrace.com';
export const DYNATRACE_SAGESYNC_ID = 'APPLICATION-163D39D28C64EDC8';
export const DYNATRACE_RUM_TOKEN = 'API-Token dt0c01.L3H747AFWN5MDW3RDEKTI5CJ.DRRYSBRXORGHXRTGKCTEFBQWAMUWITNT4X3KRZJIX5P5COP3RCWWQWGH3H6ZFCU6';

// TODO: remove these if we take it into production, we'll use a new company setting to enable per dealer
export const CTG_COMPANY_CODE = 'CABINETS TO GO';
